import { createAction, props } from '@ngrx/store';
import { Client } from '@wdx/clmi/clmi-swagger-gen';

export const getForParty = createAction(
    '[Related Clients] Get For Party',
    props<{
        partyId: string;
        accountHoldersOnly?: boolean;
        includeSingularRoles?: boolean;
    }>(),
);

export const getForPartySuccess = createAction(
    '[Related Clients] Get For Party Success',
    props<{
        partyId: string;
        relatedClients: Client[];
    }>(),
);

export const getForPartyFailure = createAction(
    '[Related Clients] Get For Party Failure',
    props<{
        partyId: string;
        error: Error;
    }>(),
);
